import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = ({ settings }) => {
  const currentYear = new Date().getFullYear();
  const data = settings || companyInfo;

  return (
    <footer className="bg-stone-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-clay-primary">
              {data.companyName || data.name || 'HALLSTATT'}
            </h3>
            <p className="text-stone-300 mb-4">
              Fabricación de maquinaria industrial para cerámica. Diseño, calidad y precisión.
            </p>
            <div className="flex space-x-4">
              <a
                href={data.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-stone-800 hover:bg-clay-primary rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={data.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-stone-800 hover:bg-clay-primary rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-stone-300 hover:text-clay-primary transition-colors duration-200"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('machines')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-stone-300 hover:text-clay-primary transition-colors duration-200"
                >
                  Máquinas
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-stone-300 hover:text-clay-primary transition-colors duration-200"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-stone-300 hover:text-clay-primary transition-colors duration-200"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-clay-primary flex-shrink-0" />
                <span className="text-stone-300">{data.phone}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-clay-primary flex-shrink-0" />
                <span className="text-stone-300">{data.email}</span>
              </li>
              <li className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-clay-primary flex-shrink-0" />
                <span className="text-stone-300">Buenos Aires, Argentina</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 mt-12 pt-8 text-center">
          <p className="text-stone-400 text-sm">
            © {currentYear} {data.companyName || 'Hallstatt'}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
